module.exports = __webpack_public_path__ + "img/colorful2-start.bea8ec38.png";